.modalButton {
    height: 37px;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.modalSaveButton {
    background-color: rgb(16 185 129) !important;
}

.modalButtonContainer {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
}
